import API from "./api";

const UtilisateurService = {
  getAll: async () => {
    const response = await API.get("/utilisateurs");
    return response.data.donnees;
  },

  bloquer: async (id: string) => {
    const response = await API.patch(`/utilisateurs/${id}/bloquer`);
    return response.data.donnees;
  },

  debloquer: async ({ id, message }: { id: string; message: string }) => {
    const response = await API.patch(`/utilisateurs/${id}/debloquer`, { message });
    return response.data.donnees;
  },

  leverVerrouTemporaire: async (id: string) => {
    const response = await API.patch(`/utilisateurs/${id}/lever-verrou-temporaire`);
    return response.data.donnees;
  },

  supprimer: async (id: string) => {
    const response = await API.delete(`/utilisateurs/${id}`);
    return response.data.donnees;
  },
};

export default UtilisateurService;
